import './Banner.css'

export const Banner = () => {
    return (
        <header className="banner">
            <h1>LISTA DE TECNOLOGIAS DE INTERESSE</h1>
        </header>
    )
}

export default Banner